import i18n from "@/plugins/vue-i18n";

const ContextualBundleListIndex = () =>
  import(
    /* webpackChunkName: "contextual" */ "@/views/advert/contextual-bundles/ContextualBundleListIndexPage.vue"
  );

const contextualBundles = [
  {
    path: "/contextual",
    name: "AdvertContextualBundles",
    component: ContextualBundleListIndex,
    meta: {
      title: i18n.t("title.contextualBundles"),
    },
  },
];

export default contextualBundles;
